import { render, staticRenderFns } from "./Obstacle.vue?vue&type=template&id=3dd61733&"
import script from "./Obstacle.vue?vue&type=script&lang=js&"
export * from "./Obstacle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports